export default "__VITE_ASSET__BrlJsU7K__"